import i18next from "i18next";
import { generatePath } from "react-router";
import { createSelector } from "reselect";
import { CLUSTER_DEFINITIONS } from "utils/constants/routes";
import { getEntity } from "utils/entities";
import { formatTags } from "utils/presenters";
import { PolicySchema } from "utils/schemas";
import allPermissions from "services/permissions";

export const getClusterDefinitionsLink = () => {
  const viewTabOrder = [
    {
      tab: "policies",
      permissions: [
        "spcPolicy.create",
        "spcPolicy.delete",
        "spcPolicy.get",
        "spcPolicy.list",
        "spcPolicy.update",
      ],
    },
    {
      tab: "templates",
      permissions: [
        "clusterTemplate.create",
        "clusterTemplate.delete",
        "clusterTemplate.get",
        "clusterTemplate.list",
        "clusterTemplate.update",
      ],
    },
  ];
  const tab = viewTabOrder.find((tab) =>
    allPermissions.has(tab.permissions)
  )?.tab;

  if (!tab) {
    return;
  }

  return generatePath(CLUSTER_DEFINITIONS.ROOT, {
    tab,
  });
};

export const getMaintenancePolicyFormError = createSelector(
  (state) => state.forms?.maintenancePolicy,
  (state) => state.language.language,
  (form) => {
    if (!form) {
      return null;
    }

    const { errors = [] } = form;
    const filteredErrors = errors.filter((error) => error.result);

    if (!filteredErrors.length) {
      return null;
    }

    let message = i18next.t(
      "Please resolve the errors on the page in order to continue"
    );

    return message;
  }
);

export const getMaintenancePolicyPayload = createSelector(
  (state) => state.forms.maintenancePolicy?.data,
  (formData = {}) => {
    const { name = "", schedules = [], tags = [] } = formData;
    return {
      metadata: {
        name,
        labels: formatTags(tags),
      },
      spec: {
        schedules: schedules.map(({ name, startCron, durationHrs }) => ({
          name,
          startCron,
          durationHrs,
        })),
      },
    };
  }
);

export const getRawPolicy = getEntity(
  (state) => state.policies?.currentPolicyGuid,
  PolicySchema
);

export const getMaintenanceAPIEndpoint = createSelector(
  (state) => state.forms.maintenancePolicy?.data,
  (formData = {}) => {
    const { isEdit, uid } = formData;
    return isEdit
      ? `v1/spcPolicies/maintenance/${uid}`
      : `v1/spcPolicies/maintenance`;
  }
);

export const getMaintenanceAPIMethod = createSelector(
  (state) => state.forms.maintenancePolicy?.data,
  (formData = {}) => {
    const { isEdit } = formData;
    return isEdit ? "PUT" : "POST";
  }
);
